<template>
    <public-frame :menu="false">
        <div class="page-body">
            <div class="ctr body-container h-100 py-2" v-if="error==='NOT-FOUND'">
                <div class="flex-in-middle h-100">
                    <div class="error-404 flex-in-middle">
                        <div class="text-center">
                            <h1 class="text-danger">{{ $t("MESSAGE.NOT-FOUND") }}</h1>
                            <br/>
                            <h3><a href="javascript://void(0);" @click="$router.push('/portal')" style="cursor: pointer; text-decoration: none;color: black">{{$t('TITLE.GO-BACK')}}</a></h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body-container ctr bg-white  d-flex flex-column h-100" v-else-if="error==='NOT-INVITED'">
                <div class="flex-in-middle h-100">
                    <div class="flex-in-middle">
                        <div class="text-center"><h1 class="text-danger">{{ $t("MESSAGE.NOT-INVITED") }}</h1>
                        <br />
                            <h3><a href="javascript://void(0);" @click="$router.push('/portal')" style="cursor: pointer; text-decoration: none;color: black">{{$t('TITLE.GO-BACK')}}</a></h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body-container ctr bg-white  d-flex flex-column h-100" v-else-if="error==='NOT-ALLOWED'">
                <div class="flex-in-middle h-100">
                    <div class="flex-in-middle">
                        <div class="text-center"><h1 class="text-danger">{{ $t("MESSAGE.NOT-ALLOWED") }}</h1>
                            <br />
                            <h3><a href="javascript://void(0);" @click="$router.push('/portal')" style="cursor: pointer; text-decoration: none;color: black">{{$t('TITLE.GO-BACK')}}</a></h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body-container ctr bg-white  d-flex flex-column h-100" v-else-if="error==='INTERNAL-ONLY'">
                <div class="flex-in-middle h-100">
                    <div class="flex-in-middle">
                        <div class="text-center"><h1 class="text-danger">{{ $t("MESSAGE.INTERNAL-ONLY") }} ({{single.ip_address}})</h1>
                        <br />
                            <h3><a href="javascript://void(0);" @click="$router.push('/portal')" style="cursor: pointer; text-decoration: none;color: black">{{$t('TITLE.GO-BACK')}}</a></h3>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="error==='WRONG-PASSCODE'"
                 class="bg-white body-container d-flex flex-column ctr">
                <div class=" bg-white h-100">
                    <div class="information-row d-flex">
                        <div class="cover">
                            <img :src="single.picture_url" class="responsive-image" alt="" style="border-radius: 5px;">
                        </div>
                        <div class="information ml-3 d-flex" style="flex-direction: column">
                            <div class="title">{{ single.subject }}</div>
                            <div class="mt-3 text">{{ single.teacher_name }}</div>
                            <div class="mt-2 text">{{ single.good_time }}</div>
                            <div class="mt-2 text">{{ english ? single.city_english : single.city_name }} |
                                {{ english ? single.department_english : single.department_name }}
                            </div>
                            <div class="mt-2 text text-danger" style="height: 20px;"></div>
                            <div>
                                <el-button type="primary" class="mt-4" icon="el-icon-caret-right" disabled>
                                    {{ $t('TITLE.ENTER-LIVE') }}
                                </el-button>
                            </div>
                        </div>
                    </div>
                    <div class="line mt-3 mb-3 flex-grow-0"></div>
                    <div class="flex-grow-1 overflow-auto">
                        <div><b>{{ $t('TITLE.DESCRIPTION') }}</b></div>
                        <div class="mt-3" v-html="single.description"></div>
                    </div>
                    <el-dialog visible :close-on-click-modal="false"
                               :show-close="false"
                               :close-on-press-escape="false"
                               :title="$t('TITLE.INFO')"
                               width="30%">
                        <div class="text-center">
                            <h3 class="">{{$t("MESSAGE.INPUT-PASSCODE")}}</h3>
                            <el-input size="large" v-model="passcode" v-el-round-input
                                      style="width: 300px;font-size: 28px;margin: auto;"
                                      @keypress.enter="handlePasscode"
                                      class="mt-4" :class="!process.loading?'shaky':''">
                            </el-input>
                        </div>
                        <span slot="footer">
                        <el-button type="primary" @click="handlePasscode" icon="el-icon-position"
                                   :loading="process.loading"> {{ $t('TITLE.SUBMIT') }}</el-button>
                    </span>
                    </el-dialog>
                </div>
            </div>
        </div>
    </public-frame>
</template>

<script>

import PublicFrame from "@/components/public-frame-dark";
import "@/common/directives/el-round-input"
import CommonMixin from "@/common/mixins/common-mixin"
import "@/scss/shaky.scss"

export default {
    name: "play-error-page",
    components: {PublicFrame},
    mixins: [CommonMixin],
    data() {
        return {
            passcode: "",
        }
    },
    props: {
        dark: {
            type: Boolean, default() {
                return false;
            }
        },
        single: {
            type: Object,
            default() {
                return {};
            }
        },
        error: {
            type: String,
            default() {
                return "";
            }
        },
    },
    methods: {
        handlePasscode() {
            this.$emit('passcode', this.passcode);
        }
    }
}
</script>

